export function nextFrame():Promise<void>
{
  let promise = new Promise<void>(    
    ( resolve, reject ) =>
    {
      requestAnimationFrame( () => { resolve(); } );
    }
  );

  return promise;
}